import store from '../../../core/store';

export const listPlanSettingTemplates = (stage_id) => {
  return store.dispatch({
    action: 'table.plan_setting_templates/LIST_PLAN_SETTING_TEMPLATES',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/plan_setting_templates',
    main: true,
  });
};

export const createPlanSettingTemplates = (stage_id, formData) => {
  return store.dispatch({
    action: 'table.plan_setting_templates/CREATE_PLAN_SETTING_TEMPLATE',
    method: 'POST',
    endpoint: '/stages/' + stage_id + '/plan_setting_templates',
    data: formData,
  });
};

export const updatePlanSettingTemplates = (
  plan_setting_template_id,
  formData
) => {
  return store.dispatch({
    action: 'table.plan_setting_templates/CREATE_PLAN_SETTING_TEMPLATE',
    method: 'PUT',
    endpoint: '/plan_setting_templates/' + plan_setting_template_id,
    data: formData,
  });
};

export const readPlanSettingTemplates = (
  plan_setting_template_id,
  formData
) => {
  return store.dispatch({
    action: 'table.plan_setting_templates/READ_PLAN_SETTING_TEMPLATE',
    method: 'GET',
    endpoint: '/plan_setting_templates/' + plan_setting_template_id,
  });
};

export const deletePlanSettingTemplate = (plan_setting_template_id) => {
  return store.dispatch({
    action: 'table.plan_setting_templates/DELETE_PLAN_SETTING_TEMPLATE',
    method: 'DELETE',
    endpoint: '/plan_setting_templates/' + plan_setting_template_id,
  });
};
